import { z } from 'zod'

const tokenContractAddressMappingSchema = z.object({
  contract_address: z.string(),
  token_id: z.string(),
  token_sym: z.string(),
  chain: z.string(),
  source: z.string(),
  id: z.string(),
})
export type TokenContractAddressMapping = z.infer<typeof tokenContractAddressMappingSchema>

export const fetchTokenContractAddressMappings = z.object({
  result: z.array(tokenContractAddressMappingSchema),
})
